export class ErrorLogDetails  {
    public FileName: string;
    public ErrorMessage: string;
}